
import {IUserPurchaseItem} from "@/interfaces/mlm";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class ReferralTable extends Vue {
    @Prop({type: String, default: ''}) readonly purchaseTitle!: string;
    @Prop({ type: Array, default: () => [] }) readonly purchaseItems!: IUserPurchaseItem[];
    @Prop({type: Boolean, default: true}) readonly isTariff!: Boolean;
    @Prop({type: Boolean, default: true}) readonly isUpgradable!: Boolean;

   public formatDate(date: string): string {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
    }
}

